const feeBandThresholds = {
  rightOn: 0.05,
  around: 1,
  little: 3,
} as const;

export function getDirectoryFeeBandThresholds() {
  return feeBandThresholds;
}

export type FeeBand =
  | 'rightOn'
  | 'around'
  | 'littleAbove'
  | 'littleBelow'
  | 'wellAbove'
  | 'wellBelow';

export function getFeeBand(
  differencePoints: number,
  thresholds = getDirectoryFeeBandThresholds(),
): FeeBand {
  const abs = Math.abs(differencePoints);

  if (abs < thresholds.rightOn) {
    return 'rightOn';
  }

  if (abs <= thresholds.around) {
    return 'around';
  }

  if (abs <= thresholds.little) {
    return differencePoints > 0 ? 'littleAbove' : 'littleBelow';
  }

  return differencePoints > 0 ? 'wellAbove' : 'wellBelow';
}

export function formatFeeBandHeadline(options: {
  band: FeeBand;
  areaName: string;
}): string {
  const { band, areaName } = options;

  switch (band) {
    case 'rightOn':
      return `Right on the ${areaName} average`;
    case 'around':
      return `Around the ${areaName} average`;
    case 'littleAbove':
      return `A little above the ${areaName} average`;
    case 'littleBelow':
      return `A little below the ${areaName} average`;
    case 'wellAbove':
      return `Well above the ${areaName} average`;
    case 'wellBelow':
      return `Well below the ${areaName} average`;
    default: {
      const _exhaustive: never = band;
      return _exhaustive;
    }
  }
}
